import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { AlertDto, UserDto } from '@system-shared/classes.dto';


@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  private url = environment.apiUrl + 'alerts'

  constructor (private http: HttpClient) {};

  getAllAlerts(){
    return this.http.get(this.url, { withCredentials: true });
  }

  getPublicAlerts() {
    return this.http.get(this.url + '/public');
  }

  getAdminAlerts() {
    return this.http.get(this.url + '/admin', { withCredentials: true });
  }

  createAlert(body: AlertDto) {
    return this.http.post(this.url, body, { withCredentials: true })
  }

  deleteAlert(id: string) {
    return this.http.delete(this.url + `/${id}`, { withCredentials: true })
  }
}
